import instance from '../instance'
export default class Vendors {
  static getManyCheckRequestForm(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions`,
      method: 'GET',
      params: params
    })
  }

  static getManyWithStatus(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/get-all-with-status`,
      method: 'GET',
      params: params
    })
  }

  static ForApproval(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/for-approval`,
      method: 'PUT',
      params: params
    })
  }

  static return(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/return`,
      method: 'PUT',
      params: params
    })
  }

  static checkPreparation(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/check-preparation`,
      method: 'PUT',
      params: params
    })
  }

  static checkPrepared(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/check-prepared`,
      method: 'PUT',
      params: params
    })
  }

  static checkAvailable(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/check-available`,
      method: 'PUT',
      params: params
    })
  }

  static inProcess(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/in-process`,
      method: 'PUT',
      params: params
    })
  }

  static forEndorsement(params = [], onHold) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/for-endorsement/${onHold}`,
      method: 'PUT',
      params: params
    })
  }

  static onHold(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/on-hold`,
      method: 'PUT',
      params: params
    })
  }

  static onHoldById(id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/on-hold/${id}`,
      method: 'PUT'
    })
  }

  static getManyDepartmentHead(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/department-head`,
      method: 'GET',
      params: params
    })
  }

  static downloadAttachment(id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/get-attachment/${id}`,
      method: 'GET',
      responseType: 'blob'
    })
  }

  static downloadAttachmentProjectClass(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/get-attachment-project-class`,
      method: 'GET',
      responseType: 'blob',
      params
    })
  }

  static getById(id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/${id}`,
      method: 'GET'
    })
  }

  static getByCrfNumber(crfNo) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/get-by-crf-number/${crfNo}`,
      method: 'GET'
    })
  }

  static getVendorMapping(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/vendor-mapping`,
      method: 'GET',
      params: params
    })
  }
  static getOrUpload(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/orUpload`,
      method: 'POST',
      params: params
    })
  }

  static submit(data = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions`,
      method: 'POST',
      data: data,
    })
  }

  static storeDraft(data = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/draft`,
      method: 'POST',
      data: data,
    })
  }

  static save(data = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/save`,
      method: 'PUT',
      data: data,
    })
  }

  static submitDraft(data = {}, id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/submit-draft/${id}`,
      method: 'PUT',
      data: data,
    })
  }

  static resubmit(data = {}, id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/submit-returned/${id}`,
      method: 'PUT',
      data: data,
    })
  }

  static resubmitDraft(data = {}, id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/transactions/submit-draft/${id}`,
      method: 'PUT',
      data: data,
    })
  }
}
